import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface DialogData {
  type: string;
  teamName: string;
}
@Component({
  selector: "team-dialog",
  templateUrl: "team-dialog.html",
})
export class TeamDialog {
  type: string;
  teamName: string;

  constructor(
    public dialogRef: MatDialogRef<TeamDialog>,
    @Inject(MAT_DIALOG_DATA) private data: DialogData
  ) {
    this.type = data?.type == "edit" ? "edit" : "create";
    this.teamName = data?.teamName;
  }

  save() {
    if (!this.teamName) return;
    this.dialogRef.close(this.teamName);
  }
}
